// src/services/registration_api.js
import { apiClient } from "./api_client";

const registrationApi = {
  /**
   * Send verification code to provided phone number
   * @param {string} phoneNumber - User's phone number to verify
   * @returns {Promise} Promise with verification request status
   */
  sendVerificationCode: async (phoneNumber) => {
    try {
      const response = await apiClient.post(
        "/auth/send-verification",
        { phoneNumber }
      );
      return response.data;
    } catch (error) {
      console.error("Error sending verification code:", error);
      return {
        success: true,
        message: "Verification code sent successfully (mock response)",
        // You might want to add a mock code for testing
        mockCode: "123456", // In a real app, you would not expose this
      };
      //throw error;
    }
  },

  /**
   * Verify the code entered by the user
   * @param {string} phoneNumber - User's phone number
   * @param {string} verificationCode - Code entered by user
   * @returns {Promise} Promise with verification result
   */
  verifyCode: async (verificationUuid, verificationCode) => {
    try {
      const response = await apiClient.post(
        "/auth/verify-code",
        { verificationUuid, verificationCode }
      );
      return response.data;
    } catch (error) {
      console.error("Error verifying code:", error);
      //throw error;

      // If the verification code is "123456" (our mock code), consider it valid
      const isValid = verificationCode === "123456";

      return {
        verified: isValid,
        success: isValid,
        message: isValid
          ? "Verification successful (mock response)"
          : "Invalid verification code (mock response)",
      };
    }
  },
  // Add this method to your registration_api.js file
  register: async (userData, token) => {
    try {
      const response = await apiClient.post("/auth/register", userData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Error during registration:", error);
      // Return dummy data for now
      return new Promise((resolve) => {
        // Add artificial delay to simulate API call
        setTimeout(() => {
          resolve({
            success: true,
            message: "Registration successful (mock response)",
            user: {
              id: "user_12345",
              firstName: userData.first_name,
              lastName: userData.last_name,
              email: userData.email,
              isVerified: true,
              phoneNumber: userData.phone_number,
            },
            token: "dummy_token_12345",
          });
        }, 1500); // 1.5 second delay to show loading
      });
    }
  },
  /**
   * Complete user registration after verification
   * @param {Object} userData - Complete user data including verification
   * @returns {Promise} Promise with registration result
   */
  completeRegistration: async (userData) => {
    try {
      const response = await apiClient.post(
        "/auth/complete-registration",
        userData
      );
      return response.data;
    } catch (error) {
      console.error("Error completing registration:", error);
      throw error;
    }
  },

  /**
   * Check if user has completed phone verification
   * @returns {Promise} Promise with verification status
   */
  checkVerificationStatus: async () => {
    try {
      const response = await apiClient.get("/auth/verification-status");
      return response.data.isVerified;
    } catch (error) {
      console.error("Error checking verification status:", error);
      throw error;
    }
  },
};

export default registrationApi;
